"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChainLinkSubscriptionDialog = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const ui_kit_1 = require("@dzambalaorg/ui-kit");
const sub_input_1 = require("./sub-input");
const contract_input_1 = require("./contract-input");
const ChainLinkSubscriptionDialog = (props) => {
    return ((0, jsx_runtime_1.jsxs)(ui_kit_1.FormGrid, { columns: [2], children: [(0, jsx_runtime_1.jsx)(contract_input_1.VrfConsumerInput, {}), (0, jsx_runtime_1.jsx)(sub_input_1.VrfSubInput, {})] }));
};
exports.ChainLinkSubscriptionDialog = ChainLinkSubscriptionDialog;
//# sourceMappingURL=index.js.map